import type { FC } from 'react';
import { useEffect } from 'react';

/**
 * A component used to inject the Apptoolbox Widget (https://github.com/opendoor-labs/code/tree/master/js/packages/apptoolbox-fe) to
 * provide information to users who are in QA environments. Analogous to https://github.com/opendoor-labs/code/blob/c46cab61/js/packages/cosmos/src/helpers/apptoolboxInjection.ts#L1
 * in cosmos.
 *
 * The <head> is built and served by the server, but we need this <script /> to be loaded client-side, because it performs raw
 * DOM manipulation and can cause fatal server/client hydration errors if executed by the server.
 *
 */
const CAKE_SHA1_SUM = '5DDC2AE17D5B13B4E5B3215177685116565F5058';

export const ApptoolboxInject: FC = () => {
  useEffect(() => {
    if (document.cookie.includes('qa_env=')) {
      const apptoolboxFeScript = document.createElement('script');
      apptoolboxFeScript.src = `https://odfil.es/313e5541776ac579b6959a58f1751d74e0e0e26a/static/embedded/embed.latest.js?ts=${Date.now()}`;
      apptoolboxFeScript.setAttribute('appid', CAKE_SHA1_SUM);
      apptoolboxFeScript.setAttribute('apppathprefix', '/');
      apptoolboxFeScript.setAttribute('invokeonloadmanually', 'true');
      apptoolboxFeScript.async = true;
      document.head.appendChild(apptoolboxFeScript);
    }
  }, []);

  return null;
};
